/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Internal reason a playback session ended. Mapped to the wire `er`/`rsn`
 * fields and used to derive `failure_classification`.
 */
export enum SessionEndReason {
  USER_ENDED = "USER_ENDED",
  SWITCH_CHANNEL_REQUESTED = "SWITCH_CHANNEL_REQUESTED",
  NETWORK_LOST = "NETWORK_LOST",
  END_OF_CONTENT = "END_OF_CONTENT",
  SUPERSEDED = "SUPERSEDED",
  PLAYER_ERROR = "PLAYER_ERROR",
  POLICY_BLOCK = "POLICY_BLOCK"
}
